import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getOrganizationalUnits() {
      return getState().organizationalUnits;
    },
    getOrganizationalUnitsTotalPages() {
      return getState().totalPages;
    },
    getOrganizationalUnitsFilter() {
      return getState().filter;
    },
    isRetrieveOrganizationalUnitsRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveOrganizationalUnitsRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveOrganizationalUnitsRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
